// item 714 (Chad) — the ONE "is this row archived?" test. The backend serializes `IsArchive` as
// `isArchive`, but the shared BasixBase model exposes `isArchived`, and different DTOs populate one
// or the other. A check that tests only ONE field lets archived rows leak into active lists/totals
// (items 712/713). OR-ing both is safe regardless of which field a given payload carries: an
// archived row sets at least one; a live row sets neither. Use this everywhere you exclude archived.
// eslint-disable-next-line import/prefer-default-export
export const isArchivedRow = (row: unknown): boolean => {
  const r = row as { isArchive?: boolean; isArchived?: boolean } | null | undefined;
  return !!(r && (r.isArchive || r.isArchived));
};
